import React from 'react';
import { Outlet } from 'react-router';

const BasicLayout = () => (
  <div>
    <Outlet />
  </div>
);

export default BasicLayout;
